import {Image} from '@coolcolduk/ui-image';
import {Container, Grid, Typography} from '@mui/material';

export default function UnderConstructionPage() {
  return (
    <Container maxWidth="md">
      <Grid container direction="column" justifyContent="center" alignItems="center">
        <Typography variant="h1" sx={{pt: 2, pb: 2}}>
          This page is under construction 🏗️🚧
        </Typography>
        <Image src="/under_construction.jpg" sx={{'& > img': {borderRadius: '16px'}}} width="60%" />
      </Grid>
    </Container>
  );
}
